module.exports = __webpack_public_path__ + "static/fonts/open-sans-bold.0edb762.woff2";